function validateCardPersonalCode(ssNumber: string) {
  const value = ssNumber;
  let message = '';
  let success = false;

  if (!value) {
    message = '주민번호 또는 사업자 번호 입력은 필수입니다.';
  } else if (value.length !== 6 && value.length !== 10) {
    message = '정확한 번호를 입력해 주세요.';
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}

export default validateCardPersonalCode;
